import React from "react";
import "./footer.css";

type FooterProps = {
  logoSrc: string;
  logoAlt?: string;
  slogan: string;
  companyName: string;
};

const Footer: React.FC<FooterProps> = ({
  logoSrc,
  logoAlt = "Logo",
  slogan,
  companyName,
}) => {
  const year = new Date().getFullYear();

  return (
    <footer className="ft" role="contentinfo">
      {/* Decoración (solo visual) */}
      <div className="ft-decor" aria-hidden="true">
        <div className="ft-decorLeft" />
        <div className="ft-decorRight" />
      </div>

      <div className="ft-inner">
        <a className="ft-brand" href="/" aria-label="Ir al inicio">
          <img className="ft-logo" src={logoSrc} alt={logoAlt} />
        </a>

        <p className="ft-slogan">{slogan}</p>

        <small className="ft-legal">
          © {year} {companyName}. Todos los derechos reservados.
        </small>
      </div>
    </footer>
  );
};

export default Footer;